import gql from "graphql-tag";
import { toast } from "react-toastify";

import { sentryWrappedException } from "~/utils/Utils";
import getQuery from "../utils/get_query";
import ParcisionCookies from "../../../utils/Cookies";

export default async function confirmPeraBidRequest(
  decodedResult: unknown[],
  cid: number,
  wager: number,
  estimate1: number,
  estimate2: number,
  estimate3: number,
  description: string,
  stage: string
) {
  try {
    let decodedResultTxn1;
    let decodedResultTxn2;
    if (decodedResult.length === 2) {
      decodedResultTxn1 = decodedResult[0];
      decodedResultTxn2 = decodedResult[1];
    } else {
      decodedResultTxn1 = decodedResult[0];
      decodedResultTxn2 = "";
    }

    const address = ParcisionCookies.get("address");
    const variables = {
      decodedResultTxn1,
      decodedResultTxn2,
      wager,
      estimate1,
      estimate2,
      estimate3,
      description,
      stage,
      cid,
      address,
    };

    const query = gql`
      query MyQuery(
        $decodedResultTxn1: String!
        $decodedResultTxn2: String!
        $cid: Float!
        $wager: String!
        $estimate1: String!
        $estimate2: String!
        $estimate3: String!
        $description: String!
        $stage: String!
        $address: String!
      ) {
        confirmPeraBidRequest(
          decodedResultTxn1: $decodedResultTxn1
          decodedResultTxn2: $decodedResultTxn2
          cid: $cid
          wager: $wager
          estimate1: $estimate1
          estimate2: $estimate2
          estimate3: $estimate3
          description: $description
          stage: $stage
          address: $address
        ) {
          stats {
            snap
            goptin
            gprize
          }
          local {
            snap
            stage
            estimate1
            estimate2
            estimate3
            wager
            description
            research
            tid
          }
          participants {
            addr
            snap
            estimate1
            estimate2
            estimate3
            wager
            return
            description
            research
          }
          message
        }
      }
    `;

    const data = await getQuery(query, variables);
    // @ts-expect-error
    return data.confirmPeraBidRequest;
  } catch (error) {
    toast.error("Failed to confirm bid request");
    sentryWrappedException(error);
    throw error;
  }
}
